module.exports = __webpack_public_path__ + "img/kafka.a53e76a2.svg";